export enum PerpayProduct {
    MARKETPLACE = 'marketplace',
    CARD = 'card',
    PERPAY_PLUS = 'perpayPlus',
}

export const PERPAY_PRODUCT_NAMES: {
    [key in PerpayProduct]: string;
} = {
    [PerpayProduct.MARKETPLACE]: 'Marketplace',
    [PerpayProduct.CARD]: 'Credit Card',
    [PerpayProduct.PERPAY_PLUS]: 'Perpay+',
};

export const PERPAY_PRODUCTS = [
    PerpayProduct.MARKETPLACE,
    PerpayProduct.CARD,
    PerpayProduct.PERPAY_PLUS,
] as const;
